import routeService from '../../services/route_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';
import SeleccionarInternacion from '../../components/internacion_seleccionar/admin_sel_internacion.vue';
import DatosParametricosService from '../../services/datos_parametricos_service.js';
import PacienteService from '../../services/paciente_service.js';
import ProfesionalService from '../../services/profesional_service.js';
import CirugiaService from '../../services/cirugia_service.js';
import InternacionService from '../../services/internacion_service.js';
import IntraoperatorioService from '../../services/intraoperatorio_service.js';
import ProcedimientoService from '../../services/procedimiento_service.js'
import Grid from '../../components/Grid';
// import ObraSocialService from '../../services/obras_sociales_service.js';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const datosParametricosService = new DatosParametricosService();
const pacienteService = new PacienteService();
// const obraSocialService = new ObraSocialService();
const profesionalService = new ProfesionalService();
const cirugiaService = new CirugiaService();
const internacionService = new InternacionService();
const intraoperatorioService = new IntraoperatorioService();
const procedimientoService = new ProcedimientoService();

let _this = null;
export default {
	name: 'cirugia',
	components: { SeleccionarInternacion, Grid },
	data: function() {
		return {
			titulo: 'NUEVA CIRUGIA',
			loginService: loginService,
			generalService: generalService,
			paciente: "",
			parent: this,
			procedimientosCirugia: [],
			internaciones: [],
			profesionales: [],
			procedimientos: [],
			cirujanos: [],
			primerosAyudantes: [],
			segundosAyudantes: [],
			complicaciones: [],
			intraoperatorios: [],
			cirugias: [],
			vias: [],
			previewView: [],
			validaciones: {},
			soloVer: false,
			submited: false,
			data: {internacion: {}},
			searchProfesionales: false,
			searchComplicaciones: true,
			searchProcedimientos: true,
			seleccionarInternacion: function(item) {  
				_this.setInternacion(item);
				_this.idCirujanoCirugia = null;
				_this.idPrimerAyudanteCirugia = null;
				_this.idSegundoAyudanteCirugia = null;
			},
			actions: [],
			columns: [
				{key: 'idPostoperatorio', value: 'Id'},
				{key: 'fechaAltaPostoperatorioEs', value: 'Fecha Alta'},
				//{key: 'tipoComplicacionIntraoperatorio', value: 'Tipo de Complicacion'},
				{key: 'complicacionPostoperatorio', value: 'Complicacion'},
				{key: 'detalleTratExtraPostoperatorio', value: 'Detalle tratamiento extra'},
				/*{key: 'idPrimerAyudanteCirugia', value: 'Id Primer Ayudante Cirugia'},
				{key: 'idSegundoAyudanteCirugia', value: 'Id Segundo Ayudante Cirugia'},
				{key: 'complicacionesCirugia', value: 'Complicaciones Cirugia'},
				{key: 'col1Cirugia', value: 'Col1 Cirugia'},
				{key: 'col2Cirugia', value: 'Col2 Cirugia'},
				{key: 'col3Cirugia', value: 'Col3 Cirugia'},*/
			] 
		}
	},
	created: function () {
		_this = this;
		routeService.destacarMenuItem("cirugias");
		loginService.hasPermission(true);
		if(routeService.getActualPath().includes("ver-")){
			this.soloVer = true;
		}
		this.getData();
		this.getInternaciones();
		this.searchProfesionales = true;
		this.getProfesionales();
		this.getProcedimientos();
		this.getVias();
		this.previewView = routeService.getListView();
		this.previewView = this.previewView == "" ? "cirugias": this.previewView;
	},
	methods: { 
		/*setSelected(value) {
			_this.data.idDiagnosticoInternacion = value;
		}*/
		getData: function() {
			_this.submited = true;
			setTimeout(() => {
				_this.submited = false;
			}, 3000);
			if(routeService.getParams().id != undefined || routeService.getParams().idInternacion != undefined) {
				if(!loginService.hasPermission("activar", "cirugias")) {
					routeService.goToHome();
					return;
				}
				let searchCirugia = {};
				if(routeService.getParams().id != undefined) {
					_this.data.idCirugia = routeService.getParams().id;
					searchCirugia = {idCirugia: this.data.idCirugia}
				} else {
					if(routeService.getParams().idInternacion != undefined) {
						_this.data.idInternacionCirugia = routeService.getParams().idInternacion;
						searchCirugia = {idInternacionCirugia: _this.data.idInternacionCirugia};
						_this.getDataInternacion();
					}
				}
				cirugiaService.get(searchCirugia).then(function(response) {
					if(response.body == null) {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
						return;
					}
					if(response.body && response.body.status == 'ERROR') {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
						return;
					}
					if(response.body.length > 0) {
						for (let value of response.body) {
							_this.data = {
								idCirugia: value.idCirugia,
								idInternacionCirugia: value.idInternacionCirugia,
								fechaCirugia: value.fechaCirugia,
								idViaCirugia: value.idViaCirugia,
								idCirujanoCirugia: value.idCirujanoCirugia,
								idPrimerAyudanteCirugia: value.idPrimerAyudanteCirugia,
								idSegundoAyudanteCirugia: value.idSegundoAyudanteCirugia,
								complicacionesCirugia: value.complicacionesCirugia,
								procedimientosCirugia: [], 
								col1Cirugia: value.col1Cirugia,
								col2Cirugia: value.col2Cirugia,
								col3Cirugia: value.col3Cirugia,
								internacion: value.internacion,
								/*idIntraoperatorio: value.idIntraoperatorio,
								fechaAltaIntraoperatorio: value.fechaAltaIntraoperatorio.substring(0,10),
								idCirugiaIntraoperatorio: value.idCirugiaIntraoperatorio,
								tratamientoExtraIntraoperatorio: value.tratamientoExtraIntraoperatorio,
								complicacionesIntraoperatorio: [],
								detalleTratExtraIntraoperatorio: value.detalleTratExtraIntraoperatorio,*/
								col1Intraoperatorio: value.col1Intraoperatorio,
								col2Intraoperatorio: value.col2Intraoperatorio,
								col3Intraoperatorio: value.col3Intraoperatorio,
							}; 
							_this.data.internacion.nombrePaciente = value.internacion.pacienteInternacion.nombrePaciente;
							_this.data.internacion.apellidoPaciente =  value.internacion.pacienteInternacion.apellidoPaciente;
							_this.data.internacion.dniPaciente =  value.internacion.pacienteInternacion.dniPaciente;
							_this.data.internacion.pacienteInternacion.edadPaciente = value.internacion.edadPacienteInternacion;							
							_this.data.internacion.idEspecialidadInternacion = value.internacion.idEspecialidadInternacion;
							_this.data.internacion.pacienteInternacion = pacienteService.formatPaciente(_this.data.internacion.pacienteInternacion);
							//_this.data.internacion.descripcionDatoParametrico = _this.data.internacion.idInternacion + " - " + _this.data.internacion.pacienteInternacion + " - INTERNACION: " + internacionService.formatInternacion(_this.data.internacion);
							_this.data.internacion.descripcionDatoParametrico = _this.data.internacion.pacienteInternacion + " -  INTERNACION: " + _this.data.internacion.idInternacion + " - " + internacionService.formatInternacion(_this.data.internacion);
							if(_this.data.internacion.altaInternacion && _this.data.internacion.altaInternacion.idAltaInternacion != null && _this.data.internacion.altaInternacion.idAltaInternacion > 0) {
								_this.internaciones.push(_this.data.internacion);
							}
							if(_this.soloVer) {
								_this.getDataIntraoperatorio(_this.data.idCirugia);
							}
							/*if(value.internacion) {
								value.internacion.pacienteInternacion = pacienteService.formatPaciente(value.internacion.pacienteInternacion);
								_this.setInternacion(value.internacion);
							}*/
							//_this.getProfesionales({idEspecialidadProfesional: _this.data.internacion.idEspecialidadInternacion});
							//_this.getComplicacionesCirugia();
							_this.getProcedimientosCirugia();
							
							if (value.cirujanoCirugia && value.activoCirujanoCirugia != 1) {
								if (!_this.profesionales.find(p => p.idProfesional == value.idCirujanoCirugia)) {
									_this.profesionales.push({idProfesional: value.idCirujanoCirugia, profesional: value.cirujanoCirugia, especialidadProfesional: value.especialidadProfesional });
								}
							}

							if (value.primerAyudanteCirugia && value.activoPrimerAyudanteCirugia != 1) {
								if (!_this.profesionales.find(p => p.idProfesional == value.idPrimerAyudanteCirugia)) {
									_this.profesionales.push({idProfesional: value.idPrimerAyudanteCirugia, profesional: value.primerAyudanteCirugia});
								}
							}

							if (value.segundoAyudanteCirugia && value.activoSegundoAyudanteCirugia != 1) {
								if (!_this.profesionales.find(p => p.idProfesional == value.idSegundoAyudanteCirugia)) {
									_this.profesionales.push({idProfesional: value.idSegundoAyudanteCirugia, profesional: value.segundoAyudanteCirugia});
								}
							}
							
							if(value.viaCirugia && value.viaCirugia.activoDatoParametrico != 1) {
								_this.vias.push(value.viaCirugia);
							}


							_this.titulo = 'MODIFICAR CIRUGIA';
						} 
					} 
				}, function(error) { 
					_this.submited = false;
					generalService.showRequestErrors(error, _this.$bvModal);
					return;
				});
			} else {
				if(!loginService.hasPermission("activar", "cirugias")) {
					routeService.goToHome();
					return;
				}
			}
		},
		getDataInternacion: function() {
			if(routeService.getParams().idInternacion != undefined) {
				if(!loginService.hasPermission("activar", "internaciones")) {
					routeService.goToHome();
					return;
				}
				_this.data.idInternacionCirugia = routeService.getParams().idInternacion;
				internacionService.get({idInternacion: _this.data.idInternacionCirugia}).then(function(response) {
					if(response.body == null) {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
						return;
					}
					if(response.body && response.body.status == 'ERROR') {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
						return;
					}
					if(response.body.length > 0) {
						for (let valueI of response.body) {			
							valueI.pacienteInternacion = pacienteService.formatPaciente(valueI.pacienteInternacion);				
							_this.setInternacion(valueI);
						} 
					} 
				}, function(error) { 
					_this.submited = false;
					generalService.showRequestErrors(error, _this.$bvModal);
					return;
				});
			} else {
				if(!loginService.hasPermission("activar", "internaciones")) {
					routeService.goToHome();
					return;
				}
			}
		},
		save: function() {
			let errores = this.validar();
			if (errores) {
				/*let errores = "";
				for(const prop in validaciones) {
					for(const error of validaciones[prop].errores) {
						errores+= error + '
';
					}
				}*/
				alertService.showAlert(this.$bvModal, 'warning', 'Advertencia', 'No se completaron correctamente los datos.\nVerifique los errores en el formulario.');
				return;
			}
			let data = {
				idCirugia: this.data.idCirugia,
				idInternacionCirugia: this.data.idInternacionCirugia,
				fechaCirugia: this.data.fechaCirugia,
				idViaCirugia: this.data.idViaCirugia,
				idCirujanoCirugia: this.data.idCirujanoCirugia,
				idPrimerAyudanteCirugia: this.data.idPrimerAyudanteCirugia,
				idSegundoAyudanteCirugia: this.data.idSegundoAyudanteCirugia,
				complicacionesCirugia: this.data.complicacionesCirugia,
				col1Cirugia: this.data.col1Cirugia,
				col2Cirugia: this.data.col2Cirugia,
				col3Cirugia: this.data.col3Cirugia,
				idIntraoperatorio: this.data.idIntraoperatorio,
				procedimientosCirugia: this.data.procedimientosCirugia, 
				fechaAltaIntraoperatorio: this.data.fechaAltaIntraoperatorio,
				idCirugiaIntraoperatorio: this.data.idCirugia,
				tratamientoExtraIntraoperatorio: this.data.tratamientoExtraIntraoperatorio,
				detalleTratExtraIntraoperatorio: this.data.detalleTratExtraIntraoperatorio,
				complicacionesIntraoperatorio: this.data.complicacionesIntraoperatorio,
				col1Intraoperatorio: this.data.col1Intraoperatorio,
				col2Intraoperatorio: this.data.col2Intraoperatorio,
				col3Intraoperatorio: this.data.col3Intraoperatorio,
			}; 
			this.submited = true;
			cirugiaService.save(data).then(function(response) {
				_this.submited = false; 
				if(response.body && response.body.status == 'success') {
					alertService.showSuccessToast('Datos guardados con exito.'); 
					routeService.goTo(_this.previewView); 
					return;
				}
				if(response.body && response.body.status == 'warning' && response.body.id > 0) {
					alertService.showAlert(_this.$bvModal, 'warning', 'Advertencia', response.body.message);
					//routeService.goTo('cirugias'); 
					_this.data.idCirugia = response.body.id;
					_this.getData();
					routeService.goTo('cirugia/' + response.body.id);
					return;
				}
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getProcedimientos: function() {
			_this.procedimientos = [];
			procedimientoService.get({activoProcedimiento: 1}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				_this.searchProcedimientos = false;
				if(response.body.length > 0) {
					for (let value of response.body) {
						value.descripcionDatoParametrico = value.codigoProcedimiento + " - " + value.descripcionProcedimiento + " - Nivel: " + value.nivelProcedimiento + " - " + value.subespecialidadProcedimiento;
						//value.descripcionDatoParametrico = value.descripcionProcedimiento;
						if(value.activoProcedimiento == 1)
							_this.procedimientos.push(value);	
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getComplicacionesCirugia: function() {
			_this.data.complicacionesCirugia = [];
			cirugiaService.getComplicacionesCirugia({idCirugia: _this.data.idCirugia}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						//if(value.activoDatoParametrico == 1) {
							_this.data.complicacionesCirugia.push(value.idDatoParametrico);
							_this.data.complicacionesIntraoperatorio.push(value.idDatoParametrico);
						//}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getProcedimientosCirugia: function() {
			_this.data.procedimientos = [];
			_this.searchProcedimientos = true;
			cirugiaService.getProcedimientosCirugia({idCirugia: _this.data.idCirugia}).then(function(response) {	
				_this.searchProcedimientos = false;				
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						if(!_this.data.procedimientosCirugia.find(p => p == value.idProcedimiento)) {
							_this.data.procedimientosCirugia.push(value.idProcedimiento);
							if(value.activoProcedimiento != 1) {
								value.descripcionDatoParametrico = value.codigoProcedimiento + " - " + value.descripcionProcedimiento + " - Nivel: " + value.nivelProcedimiento + " - " + value.subespecialidadProcedimiento;
								_this.procedimientos.push({idProcedimiento: value.idProcedimiento, descripcionDatoParametrico: value.descripcionDatoParametrico});
							}
						}
					}
				} 
			}, function(error) { 
				_this.searchProcedimientos = false;				
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getProfesionales: function(search) {
			if(!search)
				search = {};
			_this.searchProfesionales = true;
			if(_this.profesionales.length > 3)
				_this.profesionales = [];
			setTimeout(() => {
				profesionalService.get(search).then(function(response) {		
					if(_this.profesionales.length > 3)
						_this.profesionales = [];
					_this.searchProfesionales = false;		
					if(response.body == null) {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
						return;
					}
					if(response.body && response.body.status == 'ERROR') {
						alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
						return;
					}
					if(response.body.length > 0) {
						for (let value of response.body) {
							if(value.activoProfesional == 1) {
								let descEsp = value.especialidadProfesional != null ? ' (' + value.especialidadProfesional.descripcionDatoParametrico + ')'  : '';							
								_this.profesionales.push({idProfesional: value.idProfesional, profesional: value.nombreProfesional + ' ' + value.apellidoProfesional + ' ' + descEsp, especialidadProfesional: value.especialidadProfesional});
							}
						}
						let id = _this.data.idCirujanoCirugia;
						_this.data.idCirujanoCirugia = null;
						_this.data.idCirujanoCirugia = id;
						_this.primerAyudanteSelected();
						_this.segundoAyudanteSelected();
					} 
				}, function(error) { 
					_this.profesionales = [];
					_this.searchProfesionales = false;
					_this.submited = false;
					generalService.showRequestErrors(error, _this.$bvModal);
					return;
				});
			}, 1000);
		},
		getComplicaciones: function() {
			if(_this.complicaciones.length != 1)
				_this.complicaciones = [];
			datosParametricosService.getComplicaciones({}).then(function(response) {		
				_this.searchComplicaciones = false;			
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						if(value.activoDatoParametrico == 1) {
							_this.complicaciones.push(value);
						}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getVias: function() {
			if(_this.vias != 1) 
				_this.vias = [];
			datosParametricosService.getVias({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						if(value.activoDatoParametrico == 1) {
							_this.vias.push(value);
						}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getInternaciones: function() {
			internacionService.get({dadaAltaInternacion: false}).then(function(response) {
				_this.internaciones = [];
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(_this.data && _this.data.internacion && _this.data.internacion.altaInternacion && _this.data.internacion.altaInternacion.idAltaInternacion > 0) {
					_this.internaciones.push(_this.data.internacion);
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						let internac = {
							idInternacion: value.idInternacion,
							idPacienteInternacion: value.idPacienteInternacion,
							tipoInternacion: value.tipoInternacion,
							ambulatorioInternacion: value.ambulatorioInternacion == 1 ? 'SI' : 'NO',
							camaInternacion: value.camaInternacion,
							diagnosticoInternacion: value.diagnosticoInternacion,
							idReInternacion: value.idReInternacion,
							idUserAnteriorInternacion: value.idUserAnteriorInternacion,
							idCirugiaInternacion: value.idCirugiaInternacion,
							nombrePaciente: value.pacienteInternacion.nombrePaciente,
							apellidoPaciente: value.pacienteInternacion.apellidoPaciente,
							pacienteInternacion: pacienteService.formatPaciente(value.pacienteInternacion),
							nomyApPaciente: value.pacienteInternacion.nombrePaciente + " " + value.pacienteInternacion.apellidoPaciente,
							dniPaciente: value.pacienteInternacion.dniPaciente,
							edadPaciente: value.pacienteInternacion.edadPaciente,
							nroHcPaciente: value.pacienteInternacion.nroHcPaciente,
							obraSocialPaciente: value.pacienteInternacion.obraSocialPaciente.nombreObraSocial,
							sexoPaciente: value.pacienteInternacion.sexoPaciente == 1 ? 'M' : 'F',
							idUserInternacion: value.idUserInternacion,
							idStaffInternacion: value.idStaffInternacion,
							nombreStaffInternacion: value.nombreStaffInternacion,
							idEspecialidadInternacion: value.idEspecialidadInternacion,
							especialidadInternacion: value.especialidadInternacion,
							activoInternacion: value.activoInternacion == 1 ? 'SI' : 'NO',
							col1Internacion: value.col1Internacion,
							col2Internacion: value.col2Internacion,
							col3Internacion: value.col3Internacion,
							descripcionDatoParametrico: ''
						};
						internac.descripcionDatoParametrico = internac.pacienteInternacion + " -  INTERNACION: " + internac.idInternacion + " - " + internacionService.formatInternacion(internac);
						//if(!internac.idCirugiaInternacion) {
							_this.internaciones.push(internac); 
						//}
					} 
					if(_this.data.idCirugia) {
						_this.getCirugias();
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		formatPaciente(paciente) {
			return pacienteService.formatPaciente(paciente);
		},
		validar: function() {
			let validaciones = {};
			let errores = false;
			// if (typeof this.data.idInternacion == 'undefined' || this.data.idInternacion == '') {
			// 	errores = true;
			// 	validaciones['idInternacion'] = {errores: ['El Id Internacion es obligatorio.'], estado: false};
			// }
			if (typeof this.data.idInternacionCirugia == 'undefined' || this.data.idInternacionCirugia == ''  || this.data.idInternacionCirugia == null || this.data.idInternacionCirugia < 1) {
				errores = true;
				validaciones['idInternacionCirugia'] = {errores: ['La internacion es obligatoria.'], estado: false};
			}

			if (typeof this.data.fechaCirugia == 'undefined' || this.data.fechaCirugia == '' || this.data.fechaCirugia.length < 10) {
				errores = true;
				validaciones['fechaCirugia'] = {errores: ['La fecha de la cirugia es obligatoria.'], estado: false};
			}

			if (typeof this.data.idViaCirugia == 'undefined' || this.data.idViaCirugia == '' || this.data.idViaCirugia == null || this.data.idViaCirugia < 1) {
				errores = true;
				validaciones['idViaCirugia'] = {errores: ['La via es obligatoria.'], estado: false};
			}

			if (typeof this.data.idCirujanoCirugia == 'undefined' || this.data.idCirujanoCirugia == '' || this.data.idCirujanoCirugia == null || this.data.idCirujanoCirugia < 1) {
				errores = true;
				validaciones['idCirujanoCirugia'] = {errores: ['El cirujano es obligatorio.'], estado: false};
			}

			/*if (typeof this.data.complicacionesCirugia != 'undefined' && this.data.complicacionesCirugia != '' && this.data.complicacionesCirugia.length > 0) {
				if (typeof this.data.fechaAltaIntraoperatorio == 'undefined' || this.data.fechaAltaIntraoperatorio == '') {
					errores = true;
					validaciones['fechaAltaIntraoperatorio'] = {errores: ['La fecha de complicaciones intraoperatorias es obligatoria.'], estado: false};
				}
			}
			if (typeof this.data.tratamientoExtraIntraoperatorio != 'undefined' && this.data.tratamientoExtraIntraoperatorio == 1) {
				if (typeof this.data.fechaAltaIntraoperatorio == 'undefined' || this.data.fechaAltaIntraoperatorio == '') {
					errores = true;
					validaciones['fechaAltaIntraoperatorio'] = {errores: ['La fecha de complicaciones intraoperatorias es obligatoria.'], estado: false};
				}
			}*/
			/*if (typeof this.data.idComplicaciones == 'undefined' || this.data.idComplicaciones == '') {
				errores = true;
				validaciones['idComplicaciones'] = {errores: ['El Tipo Internacion es obligatorio.'], estado: false};
			}
			if (typeof this.data.ambulatorioInternacion == 'undefined' || (this.data.ambulatorioInternacion != 0 && this.data.ambulatorioInternacion != 1)) {
				errores = true;
				validaciones['ambulatorioInternacion'] = {errores: ['El Ambulatorio Internacion es obligatorio.'], estado: false};
			}*/
			this.validaciones = validaciones;
			return errores;
		},
		limpiarError: function (campo) {
			if (campo == undefined || campo.errores.length == 0) {
				return true;
			}
			campo.errores.length = 0;
			campo.estado = true;
		},
		cancelar: function() {
			routeService.goToBack();
		},
		selectStaff() {
			this.data.idStaffInternacion = null;
			//this.getProfesionales({idEspecialidadProfesional: this.data.idEspecialidadInternacion})
		},
		setInternacion(item) {
			if(_this.validaciones) {
				if(_this.validaciones.idInternacionCirugia) {
					_this.limpiarError(_this.validaciones.idInternacionCirugia);
				}
			}
			_this.data.idInternacionCirugia = item.idInternacion;
			_this.data.internacion.idEspecialidadInternacion = item.idEspecialidadInternacion;
			//item.ambulatorioInternacion = item.ambulatorioInternacion == 0 ? "NO" : item.ambulatorioInternacion == 1 ? "SI" : item.ambulatorioInternacion;
			_this.filterCirujanos();
			//_this.paciente = item.pacienteInternacion + ' - CAMA:' + item.camaInternacion + ' - AMBULATORIO: ' + item.ambulatorioInternacion + ' - DIAGNOSTICO: ' + item.diagnosticoInternacion + ' - ESPECIALIDAD: ' + item.especialidadInternacion + ' - STAFF: ' + item.nombreStaffInternacion;
			_this.paciente = internacionService.formatInternacion(item);
		},
		unsetInternacion() {
			_this.data.idInternacionCirugia = null;
			_this.data.internacion.idEspecialidadInternacion = null;
			//_this.getProfesionales({idEspecialidadProfesional: -1});
			_this.data.idCirujanoCirugia = null;
			_this.data.idPrimerAyudanteCirugia = null;
			_this.data.idSegundoAyudanteCirugia = null;
			_this.paciente = null;
		},
		getCirugias: function () {
			this.buscando = true;
			let internacionSeleccionada= _this.internaciones.find(i => i.idInternacion == _this.data.idInternacionCirugia);
			_this.cirugias = [];
			let pacienteInternacion = '';
			if(internacionSeleccionada) {
				pacienteInternacion = internacionSeleccionada.idPacienteInternacion;
				//_this.titulo = "CIRUGIA DE " + pacienteService.datosPersonalesPaciente(internacionSeleccionada).toUpperCase();				
			} else {
				return;
			}
			cirugiaService.get({idPacienteInternacion: pacienteInternacion}).then(function(response) {
				_this.buscando = false;
				_this.cirugias = [];
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.cirugias.push({
							idCirugia: value.idCirugia,
							idInternacionCirugia: value.idInternacionCirugia,
							
							tipoInternacion: value.internacion.tipoInternacion,
							ambulatorioInternacion: value.internacion.ambulatorioInternacion == 1 ? 'SI' : 'NO',
							camaInternacion: value.internacion.camaInternacion,
							diagnosticoInternacion: value.internacion.diagnosticoInternacion,
							idReInternacion: value.internacion.idReInternacion,
							idUserAnteriorInternacion: value.internacion.idUserAnteriorInternacion,
							pacienteInternacion: pacienteService.formatPaciente(value.internacion.pacienteInternacion),
							nomyApPaciente: value.internacion.pacienteInternacion.nombrePaciente + " " + value.internacion.pacienteInternacion.apellidoPaciente,
							dniPaciente: value.internacion.pacienteInternacion.dniPaciente,
							edadPaciente: value.internacion.pacienteInternacion.edadPaciente,
							nroHcPaciente: value.internacion.pacienteInternacion.nroHcPaciente,
							obraSocialPaciente: value.internacion.pacienteInternacion.obraSocialPaciente.nombreObraSocial,
							sexoPaciente: value.internacion.pacienteInternacion.sexoPaciente == 1 ? 'M' : 'F',
							idUserInternacion: value.internacion.idUserInternacion,
							idStaffInternacion: value.internacion.idStaffInternacion,
							nombreStaffInternacion: value.internacion.nombreStaffInternacion,
							idEspecialidadInternacion: value.internacion.idEspecialidadInternacion,
							especialidadInternacion: value.internacion.especialidadInternacion.descripcionDatoParametrico,
	
							idViaCirugia: value.idViaCirugia,
							viaCirugia:  value.viaCirugia,
							idCirujanoCirugia: value.idCirujanoCirugia,
							cirujanoCirugia: value.cirujanoCirugia,
							idPrimerAyudanteCirugia: value.idPrimerAyudanteCirugia,
							primerAyudanteCirugia: value.primerAyudanteCirugia,
							idSegundoAyudanteCirugia: value.idSegundoAyudanteCirugia,
							segundoAyudanteCirugia: value.segundoAyudanteCirugia,
							complicacionesCirugia: value.complicacionesCirugia,
							col1Cirugia: value.col1Cirugia,
							col2Cirugia: value.col2Cirugia,
							col3Cirugia: value.col3Cirugia,
						}); 
					} 
				} 
			}, function(error) { 
				_this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		internacionChange: function () {
			_this.getCirugias();
			let internacionSeleccionada= _this.internaciones.find(i => i.idInternacion == _this.data.idInternacionCirugia);
			_this.cirugias = [];
			if(internacionSeleccionada) {
				/*_this.primerAyudanteSelected
				_this.idCirujanoCirugia = null;
				_this.idPrimerAyudanteCirugia = null;
				_this.idSegundoAyudanteCirugia = null;*/
				_this.data.idCirujanoCirugia = null;
				_this.data.internacion.idEspecialidadInternacion = internacionSeleccionada.idEspecialidadInternacion;
				_this.cirujanoSelected();
				_this.idPrimerAyudanteCirugia = null;
				_this.idSegundoAyudanteCirugia = null;
			}
			//_this.getProfesionales({idEspecialidadProfesional: item.idEspecialidadInternacion});
		},
		getDataIntraoperatorio: function(idCirugia) {
			intraoperatorioService.get({idCirugiaIntraoperatorio: idCirugia, orderBy: "fecha_postoperatorio desc"}).then(function(response) {
				_this.submited = false;
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				_this.intraoperatorios = [];
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.intraoperatorios.push({
							idPostoperatorio: value.idIntraoperatorio,
							idComplicacionPostoperatorio: value.idComplicacionIntraoperatorio,
							complicacionPostoperatorio: value.complicacionIntraoperatorio.descripcionDatoParametrico,
							idTipoComplicacionIntraoperatorio: value.tipoComplicacionIntraoperatorio == "" ? "" : value.tipoComplicacionIntraoperatorio.idDatoParametrico,
							tipoComplicacionIntraoperatorio: value.tipoComplicacionIntraoperatorio == "" ? "" : value.tipoComplicacionIntraoperatorio.descripcionDatoParametrico,
							fechaAltaPostoperatorio: value.fechaAltaIntraoperatorio.substring(0,10),
							fechaAltaPostoperatorioEs: generalService.fechaSpanish(value.fechaAltaIntraoperatorio.substring(0,10)),
							idInternacionPostoperatorio: value.idInternacionIntraoperatorio,
							tratamientoExtraPostoperatorio: value.tratamientoExtraIntraoperatorio,
							detalleTratExtraPostoperatorio: value.detalleTratExtraIntraoperatorio,
							col1Postoperatorio: value.col1Intraoperatorio,
							col2Postoperatorio: value.col2Intraoperatorio,
							col3Postoperatorio: value.col3Intraoperatorio,
						});
					} 
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		filterCirujanos() {
			_this.cirujanos = [];
			/*if(_this.data.idCirujanoCirugia == _this.data.idSegundoAyudanteCirugia || _this.data.idCirujanoCirugia == _this.data.idPrimerAyudanteCirugia) {
				if(_this.data.idCirujanoCirugia) {
					_this.data.idCirujanoCirugia = null;
				}
			}*/
			_this.cirujanos = _this.profesionales.filter(p => (p.idProfesional != _this.data.idSegundoAyudanteCirugia && p.idProfesional != _this.data.idPrimerAyudanteCirugia 
																&& (p.especialidadProfesional != null && 
																((_this.data.internacion && p.especialidadProfesional.idDatoParametrico == _this.data.internacion.idEspecialidadInternacion) 
																	|| (!_this.data.internacion || !_this.data.internacion.idEspecialidadInternacion)))) 
																	|| (p.idProfesional == _this.data.idCirujanoCirugia));
			console.log(_this.cirujanos);
		},
		cirujanoSelected() {
			_this.primerosAyudantes = [];
			_this.segundosAyudantes = [];
			/*if(_this.data.idPrimerAyudanteCirugia == _this.data.idCirujanoCirugia || _this.data.idPrimerAyudanteCirugia == _this.data.idSegundoAyudanteCirugia) {
				if(_this.data.idPrimerAyudanteCirugia) {
					_this.data.idPrimerAyudanteCirugia = null;
				}
			}
			if(_this.data.idSegundoAyudanteCirugia == _this.data.idCirujanoCirugia || _this.data.idSegundoAyudanteCirugia == _this.data.idPrimerAyudanteCirugia) {
				if(_this.data.idSegundoAyudanteCirugia) {
					_this.data.idSegundoAyudanteCirugia = null;
				}
			}*/			
			_this.primerosAyudantes = _this.profesionales.filter(p => (p.idProfesional != _this.data.idCirujanoCirugia && p.idProfesional != _this.data.idSegundoAyudanteCirugia && p.especialidadProfesional == null) || (_this.data.idPrimerAyudanteCirugia == p.idProfesional));			
			_this.primerAyudanteSelected();
		},
		primerAyudanteSelected() {
			_this.segundosAyudantes = [];
			/*if(_this.data.idSegundoAyudanteCirugia == _this.data.idCirujanoCirugia || _this.data.idSegundoAyudanteCirugia == _this.data.idPrimerAyudanteCirugia) {
				if(_this.data.idSegundoAyudanteCirugia) {
					_this.data.idSegundoAyudanteCirugia = null;
				}
			}*/
			_this.segundosAyudantes = _this.profesionales.filter(p => (p.idProfesional != _this.data.idCirujanoCirugia && (p.idProfesional != _this.data.idPrimerAyudanteCirugia) && p.especialidadProfesional == null)  || (_this.data.idSegundoAyudanteCirugia == p.idProfesional));
			_this.filterCirujanos();
		},
		segundoAyudanteSelected() {
			_this.primerosAyudantes = [];
			/*if(_this.data.idSegundoAyudanteCirugia == _this.data.idCirujanoCirugia || _this.data.idSegundoAyudanteCirugia == _this.data.idPrimerAyudanteCirugia) {
				if(_this.data.idSegundoAyudanteCirugia) {
					_this.data.idSegundoAyudanteCirugia = null;
				}
			}*/
			_this.primerosAyudantes = _this.profesionales.filter(p => (p.idProfesional != _this.data.idCirujanoCirugia && (p.idProfesional != _this.data.idSegundoAyudanteCirugia) && p.especialidadProfesional == null)  || (_this.data.idPrimerAyudanteCirugia == p.idProfesional));
			_this.filterCirujanos();
		}
	}
}

